import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../../../components/Layout"
import Header from "../../../components/Header"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import ThumbnailImage from "../../../images/thumbnails/redsummit.png"

export function Index() {
  return (
    <Layout
      title="Real Estate Summit Networking & Lead Generation Success with Premagic AI"
      description="Real Estate Development Summit boosted networking and lead generation through Premagic’s AI-powered photo sharing and engagement platform."
      metaImage={ThumbnailImage}
      keywords={[
        "real estate summit case study, property development events, real estate networking, property conference photos, real estate industry events, property developer networking, real estate conference technology, property investment events, real estate marketing photos, property industry networking, real estate community building, property development conferences, real estate photo sharing, property industry solutions, construction industry events",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "Real Estate Development Summit", url: "/case-study/real-estate-development-summit/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "Real Estate Summit Networking & Lead Generation Success with Premagic AI",
            "description": "Real Estate Development Summit boosted networking and lead generation through Premagic’s AI-powered photo sharing and engagement platform.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-01-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.REDSUMMIT} />
    </Layout>
  )
}

export default Index
